(function(){
    'use strict'

    angular
    .module('app.ordenes')
    .controller('ordenes.Firmar', Firmar);

    Firmar.$inject = ['$q', '$scope', '$animationsSrv', '$routeParams','ApiBaseService', 'logger', '$location', 'UserInfoService', 'moment', 'signaturePad'];

    function Firmar($q, $scope, $animationsSrv, $routeParams, ApiBaseService, logger, $location, UserInfoService, moment, signaturePad) {
    
        $animationsSrv.scrollToTop();
        const apiOrdenes = 'api/Ordenes'
        const companiaId = UserInfoService.getCompaniaId();

        let vm = this;

        vm.data = {
        };

        vm.firmaData = {
            firmaData: null,
            firmaDataURL: null
        };

        vm.title = 'Firmar Orden';
        vm.id = $routeParams.id ? $routeParams.id : 0;

        var canvas = document.querySelector("canvas");

        var signaturePad = new signaturePad.SignaturePad(canvas);

        get();

        function get(){

                if(vm.id != 0){
                    ApiBaseService.remoteController = apiOrdenes;
                    var promise = ApiBaseService.getAll([companiaId, vm.id]);

                    promise
                    .then(function(data){
                        data.fecha = moment(data.fecha).toDate();
                        data.contratoId = data.contrato.id;
                        data.contratoCodigo = data.contrato.codigo;
                        data.clienteId = data.contrato.clienteId;
                        data.proyectoId = data.contrato.proyectoId;
                        data.todosLosProyectos = data.contrato.todosLosProyectos;
                        vm.data = data;

                        if(vm.data.firmaData)
                        {
                            signaturePad.fromData(JSON.parse(vm.data.firmaData));
                        }
                    })
                    .catch(function(error){
                        switch (error.status) {
                            case 401:
                                logger.error('La sesión ha expirado');
                                break;
                        
                            default:
                                logger.error('Hubo un error al obtener el registro: ' + error.data.Message);
                                break;
                        }
                    });               
                }
                else
                {
                    logger.error('No se ha especificado el numero de orden');
                }

        };

        vm.limpiar = function(){
            signaturePad.clear();
        };

        function doFormValidations()
        {
            if(signaturePad.isEmpty())
            {
                logger.error('No se ha firmado la orden!');
                return false;
            }

            return true;
        };

        vm.validateUser = function(){

            $scope.submittedUsuario = true;

            if($scope.logUserForm.$valid){
                
                ApiBaseService.remoteController = 'api/usuarios/login-ordenes';
                var promise = ApiBaseService.getAll([vm.data.usuario, vm.data.contrasena]);

                promise
                .then(function(data){
                    if(data)
                    {
                        vm.data.usuarioId = data.id;
                        vm.save();
                        $('#myModalLogin').modal('toggle');
                    }
                })
                .catch(function(error){

                    logger.error('Error: ' + error.data.Message);
                }); 
            }
        };

        function saveCanvasObject()
        {
            vm.firmaData = {
                firmaData: JSON.stringify(signaturePad.toData()),
                firmaDataURL: cropSignatureCanvas(canvas)
            };
        };
        vm.save = function(){

            $scope.submitted = true;

            if($scope.dataForm.$valid){
                if(!vm.data.id){
                    logger.error('No se ha definido una orden!');
                }
                else
                {
                    update();
                }
            }     
        
        };

        function update(){
            vm.data.cia_codigo = companiaId;
            ApiBaseService.remoteController = `${apiOrdenes}/Firma`;

            var transform  = {
                ordenId: vm.data.id,
                usuario: vm.data.usuario,
                usuarioId: vm.data.usuarioId,
                firmaData: vm.firmaData.firmaData,//JSON.stringify(signaturePad.toData()),
                firmaDataURL: vm.firmaData.firmaDataURL//cropSignatureCanvas(canvas) //signaturePad.toDataURL("image/png") // save image as JPEG
            };

            var promise = ApiBaseService.update(transform);
            
            promise
            .then(function(response){
                logger.success('Orden Firmada con éxito.');
                $location.path('/ordenes');
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sesión ha expirado');
                        break;
                
                    default:
                        logger.error('Hubo un error al firmar el registro: ' + error.data.Message);
                        break;
                }
            });   
        };

        vm.openModalLogin = function(){
            if(signaturePad.isEmpty()){
                   logger.info('No se ha firmado la orden!');
            }
            else{
                
                if(!doFormValidations())
                {
                    return;
                }
    
                saveCanvasObject();

                vm.data.usuario = '';
                vm.data.contrasena = '';
                $scope.submittedUsuario = false;
                $scope.logUserForm.$setPristine();
                // Since Angular 1.3, set back to untouched state.
                $scope.logUserForm.$setUntouched();

                $('#myModalLogin').modal('toggle');
            }
             
        };

        function clearData(){
            $scope.submitted = false;
            // Reset the form model.
            vm.data = {};
            vm.firmaData = {
                firmaData: null,
                firmaDataURL: null
            };
            // Set back to pristine.
            $scope.dataForm.$setPristine();
            // Since Angular 1.3, set back to untouched state.
            $scope.dataForm.$setUntouched();
        };

        function resizeCanvas() {
            var ratio =  Math.max(window.devicePixelRatio || 1, 1);
            canvas.width = canvas.offsetWidth * ratio;
            canvas.height = canvas.offsetHeight * ratio;
            canvas.getContext("2d").scale(ratio, ratio);
            signaturePad.clear(); // otherwise isEmpty() might return incorrect value
        }
        
        window.addEventListener("resize", resizeCanvas);
        resizeCanvas();

        function cropSignatureCanvas(canvas) {

            // First duplicate the canvas to not alter the original
            var croppedCanvas = document.createElement('canvas'),
                croppedCtx    = croppedCanvas.getContext('2d');

                croppedCanvas.width  = canvas.width;
                croppedCanvas.height = canvas.height;
                croppedCtx.drawImage(canvas, 0, 0);

            // Next do the actual cropping
            var w         = croppedCanvas.width,
                h         = croppedCanvas.height,
                pix       = {x:[], y:[]},
                imageData = croppedCtx.getImageData(0,0,croppedCanvas.width,croppedCanvas.height),
                x, y, index;

            for (y = 0; y < h; y++) {
                for (x = 0; x < w; x++) {
                    index = (y * w + x) * 4;
                    if (imageData.data[index+3] > 0) {
                        pix.x.push(x);
                        pix.y.push(y);

                    }
                }
            }
            pix.x.sort(function(a,b){return a-b});
            pix.y.sort(function(a,b){return a-b});
            var n = pix.x.length-1;

            w = pix.x[n] - pix.x[0];
            h = pix.y[n] - pix.y[0];
            var cut = croppedCtx.getImageData(pix.x[0], pix.y[0], w, h);

            croppedCanvas.width = w;
            croppedCanvas.height = h;
            croppedCtx.putImageData(cut, 0, 0);

            return croppedCanvas.toDataURL();
        };

    }
})();